import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { WebSocketStore } from '../stores';

export const useWebSocketStore = () =>
  useContext<{
    webSocketStore: WebSocketStore;
  }>(StoreContext);
